import { graphql } from '../gql';
import { useMutation } from '@apollo/client';
import type { ClaimInput } from '../gql/graphql';

export const UPSERT_CLAIM_DATA = graphql(`
  mutation upsertClaimData($claimInput: ClaimInput!) {
    upsertClaim(details: $claimInput) {
      uuid
      claimVariant
      cryptoWalletId
      lengthOfDisruption
      recordsImpacted
      initialBudget

      numberOfEndpoints
      paid
      typePaid
      daysOccurrenceToDetection
      daysDetectionToContainment
      dataLoss
      initialDemand
      daysDetectionToForensicCompletion
      dataMined
      finalPayment
      rorSentDate
      ftfAmountOriginalLoss
      polSentDate
      ftfAmountRecovered
      becAccountsCompromised
      contributionFromOtherInsurance
      catCodeUuid
    }
  }
`);

export interface IUseUpsertClaimDataMutationArg {
  claimInput: ClaimInput;
}

export function useUpsertClaimDataMutation() {
  const [upsertClaimData, { loading, error, data }] =
    useMutation(UPSERT_CLAIM_DATA);

  const executeUpsertClaimData = (
    variables: IUseUpsertClaimDataMutationArg
  ) => {
    return upsertClaimData({
      variables,
    });
  };

  return {
    upsertClaimData: executeUpsertClaimData,
    loading,
    error,
    data,
  };
}
